import {Asset, AssetType, QUESTION_TYPE, Question, Test} from '../graphql/API';
import type {
  QuestionWithNewFields,
  TestDraft,
} from '../modules/Questions/QuestionTypes';
import {BackendQuestionType} from '../types/newQuestionType';

const PHOTO_TYPES = ['png', 'jpg', 'jpeg'];
export const validateCreateTest = (test: TestDraft) => {
  if (test.name?.length === 0) {
    return {status: false, message: 'Please enter test name'};
  }
  if (test.summary?.length === 0) {
    return {status: false, message: 'Please enter test summary'};
  }
  if (test.description?.length === 0) {
    return {status: false, message: 'Please enter test description'};
  }

  let testAssetValidation = validateCreateAsset(test?.asset!);
  if (!testAssetValidation.status) {
    return {
      status: false,
      message: 'Test asset:\n' + testAssetValidation.message,
    };
  }
  let questionsValidationResults = test.questions?.map((question, index) => {
    //@ts-ignore
    return validateQuestion(question, index);
  });

  let errorsList = questionsValidationResults?.filter(r => !r.status);

  if (errorsList?.length !== 0) {
    // @ts-ignore
    return errorsList[0];
  } else {
    return {status: true, message: 'Valid test'};
  }
};

export const validateCreateAsset = (asset: Asset) => {
  // Handle null/undefined assets or assets without a type (optional assets)
  if (!asset || !asset.type) {
    return {status: true, message: 'No asset to validate'};
  }

  console.log('ASDSDDS', asset);
  switch (asset?.type) {
    case AssetType.AUDIO:
      return validateAudioAsset(asset);
    case AssetType.PHOTO:
      return validatePhotoAsset(asset);
    case AssetType.VIDEO:
      return validateVideoAsset(asset);
    default:
      return {status: false, message: 'Please select asset type'};
  }
};

const validateAudioAsset = (asset: Asset) => {
  let fileUriArray = asset.fileUri?.split('.');
  //@ts-ignore
  let fileExtension = fileUriArray[fileUriArray.length - 1];
  if (fileExtension.toLocaleLowerCase() === 'aac') {
    return {status: true, message: 'Valid audio Asset'};
  } else {
    return {status: false, message: 'Audio must be AAC'};
  }
};

const validateVideoAsset = (asset: Asset) => {
  console.log('ASSETTTTTTT,a,as', asset);

  // Video file validation
  let fileUriArray = asset.fileUri?.split('.');
  //@ts-ignore
  let fileExtension =
    fileUriArray?.[fileUriArray.length - 1]?.toLocaleLowerCase();

  if (fileExtension !== 'mp4') {
    return {status: false, message: 'Video must be mp4'};
  }

  // Thumbnail validation - ONLY if thumbnail is provided
  if (asset.thumbnailUri && asset.thumbnailUri.trim().length > 0) {
    let thumbnailUriArray = asset.thumbnailUri.split('.');
    //@ts-ignore
    let thumbnailExtension =
      thumbnailUriArray[thumbnailUriArray.length - 1]?.toLocaleLowerCase();

    console.log('thumbnailUriArray,a,as', thumbnailUriArray);

    if (!PHOTO_TYPES.includes(thumbnailExtension)) {
      return {status: false, message: 'Thumbnail must be jpg, png or jpeg'};
    }
  }

  return {status: true, message: 'Valid video asset'};
};

const validatePhotoAsset = (asset: Asset) => {
  let fileUriArray = asset.fileUri?.split('.');
  //@ts-ignore
  // let fileExtension = fileUriArray[fileUriArray.length - 1].toLocaleLowerCase();

  let thumbnailUriArray = asset.thumbnailUri?.split('.');
  //@ts-ignore
  let thumbnailExtension =
    thumbnailUriArray[
      //@ts-ignore
      thumbnailUriArray.length - 1
    ].toLocaleLowerCase();

  if (!PHOTO_TYPES.includes(thumbnailExtension)) {
    return {
      status: false,
      message: 'Thumbnail extension must be jpg, png or jpeg',
    };
  }
  // if (!PHOTO_TYPES.includes(fileExtension)) {
  //   return {status: false, message: 'File extension must be jpg, png or jpeg'};
  // }
  return {status: true, message: 'Valid photo asset'};
};

export const validateQuestion = (
  question: QuestionWithNewFields,
  i: number,
) => {
  if (question.name?.length === 0) {
    return {
      status: false,
      message: 'Question ' + i + ' name:\n Please enter question name',
    };
  }
  if (question.summary?.length === 0) {
    return {
      status: false,
      message: 'Question ' + i + ' summary:\n Please enter question summary',
    };
  }
  if (question.description?.length === 0) {
    return {
      status: false,
      message:
        'Question ' + i + ' description:\n Please enter question description',
    };
  }

  if (!question.program || question.program.length === 0) {
    return {
      status: false,
      message: 'Question ' + i + ' program:\n Please select a program',
    };
  }

  if (question.text?.length === 0) {
    return {
      status: false,
      message: 'Question ' + i + ' text:\n Please enter question text',
    };
  }

  if (question.type === QUESTION_TYPE.COMPREHENSION) {
    if (!question?.customChoices) {
      return {
        status: false,
        message: 'Question ' + i + ' text:\n Please enter question choices',
      };
    } else if (
      question?.customChoices &&
      Object.values(question.customChoices).some(
        arr => Array.isArray(arr) && arr.length < 2,
      )
    ) {
      return {
        status: false,
        message:
          'Question ' + i + ' text:\n you must enter at least two list choices',
      };
    } else if (
      Object.values(question?.customChoices).some(
        arr => Array.isArray(arr) && arr.length < 2,
      )
    ) {
      return {
        status: false,
        message: 'Question ' + i + ' text:\n you must fill the choices values',
      };
    }
    //@ts-ignore
    else if (!question?.correctIndex) {
      return {
        status: false,
        message: 'Question ' + i + ' text:\n you must enter the correct answer',
      };
    } else if (
      //@ts-ignore
      Object.keys(question?.correctIndex).length !=
      Object.keys(question?.customChoices).length
    ) {
      return {
        status: false,
        message: 'Question ' + i + ' text:\n Review question correct answer.',
      };
    } else {
      Object.keys(question?.customChoices).forEach((val: string) => {
        console.log(
          'Object.keys(question?.customChoices',
          question?.customChoices[val],
        );
        if (question?.customChoices[val].length === 0) {
          return {
            status: false,
            message:
              'Question ' +
              i +
              ' text:\n you must enter at least one choice per list of choices',
          };
        }
      });
    }
  }

  if ((question.type as string) === BackendQuestionType.REARRANGE_SENTENCE) {
    const words = (question.textAI || question.AiText || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);

    if (words.length < 2) {
      return {
        status: false,
        message:
          'Question ' +
          i +
          ' textAI:\n REARRANGE_SENTENCE requires at least two words',
      };
    }
  }

  if ((question.type as any) === 'DESCRIBE_IMAGE') {
    if (question?.asset.thumbnailUri == '') {
      return {
        status: false,
        message:
          'Question ' + i + ' text:\n Please upload the image to describe',
      };
    }
  }

  if (
    question.type !== QUESTION_TYPE.TRANSCRIBE_AND_SCORE &&
    (!question.textAI || question.textAI.trim().length === 0)
  ) {
    return {
      status: false,
      message: 'Question ' + i + ' textAI:\n Please enter question text AI',
    };
  }

  // Only validate assets that have been configured with files
  // Assets are optional, so we skip validation for null/undefined or empty assets
  if (
    question.asset &&
    question.asset.type &&
    (question.asset.fileUri?.length > 0 ||
      question.asset.thumbnailUri?.length > 0)
  ) {
    let questionAssetValidation = validateCreateAsset(question.asset);
    if (!questionAssetValidation.status) {
      return {
        status: false,
        message:
          'Question ' + i + ' asset:\n' + questionAssetValidation.message,
      };
    }
  }

  if (question?.correctAsset) {
    if (question?.correctAsset?.fileUri?.length !== 0) {
      console.log('question', question);
      let questionCorrectAssetValidation = validateCreateAsset(
        question.correctAsset!,
      );
      if (!questionCorrectAssetValidation.status) {
        return {
          status: false,
          message:
            'Question ' +
            i +
            ' correct asset:\n' +
            questionCorrectAssetValidation.message,
        };
      }
    }
  }

  return {
    status: true,
    message: 'Question ' + i + ' is valid',
  };
};
